import { post, excluir } from './AcessoApi'
import { mostrarToast } from '../components/Toasts'
import { getUsuario } from './Configuracoes'
import moment from 'moment'

const ordenarArrayObj = (array, atributo) => array.sort((a, b) => a[atributo] > b[atributo] ? 1 : b[atributo] > a[atributo] ? -1 : 0)

const downloadArquivoS3 = (s3Key) => {
    Promise.resolve(post('/sistema/aws-s3-obter-arquivo', {
        fileKey: s3Key
    })).then(val => {
        window.open(val.data.returnData, "_blank")
    }).catch((e) => mostrarToast('erro', e))
}

const auditar = (acao, modulo, controle) => {
    const objAuditar = {
        usuario_id: getUsuario().id,
        modulo_id: modulo,
        acao_id: acao,
        controle: controle || null
    }

    post('/controleAcesso/auditoria/salvar', objAuditar)
}

const removeAcentos = (str) => {
    let comAcento = 'ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ'
    let semAcento = 'AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr'
    let novaString = ''

    for (let i = 0; i < str.length; i++) {
        let troca = false;

        for (let a = 0; a < comAcento.length; a++)
            if (str.substr(i, 1) === comAcento.substr(a, 1)) {
                novaString += semAcento.substr(a, 1);
                troca = true;
                break;
            }

        if (troca === false)
            novaString += str.substr(i, 1);
    }

    return novaString;
}

const emptyObject = obj => {
    for (var key in obj)
        if (obj.hasOwnProperty(key))
            return false;

    return true;
}

const calcularData = (data_base, valor, modo_visualizacao, callback) => {
    let novosFiltros = { modo_visualizacao: modo_visualizacao }
    let tipoContagem = '';
    let today = moment(data_base, 'DD/MM/YYYY');
    switch (modo_visualizacao) {
        case 1:
            today = valor === 0 ? moment() : today;
            tipoContagem = 'days'

            if (valor.toString().includes('/')) {
                novosFiltros = {
                    data_inicial: valor,
                    data_final: valor, ...novosFiltros
                }
            } else {
                today = valor === 0 ? moment() : today;
                novosFiltros = {
                    data_inicial: today.clone().add(valor, tipoContagem).format('DD/MM/YYYY'),
                    data_final: today.clone().add(valor, tipoContagem).format('DD/MM/YYYY'), ...novosFiltros
                }
            }
            break;
        case 2:
            let from_date
            let to_date
            tipoContagem = 'weeks'

            if (valor.toString().includes('/')) {
                today = moment(valor, 'DD/MM/YYYY');
                from_date = today.startOf('week').toDate()
                to_date = today.endOf('week').toDate()
            }
            else {
                from_date = today.startOf('week').toDate()
                to_date = today.endOf('week').toDate()
            }

            novosFiltros = {
                data_inicial: moment(from_date).add(valor, tipoContagem).format('DD/MM/YYYY'),
                data_final: moment(to_date).add(valor, tipoContagem).format('DD/MM/YYYY'), ...novosFiltros
            }
            break;
        case 3:
            tipoContagem = 'months'
            let from_date_month
            let to_date_month

            if (valor.toString().includes('/')) {
                today = moment(valor, 'DD/MM/YYYY');
                from_date_month = today.startOf('month').toDate()
                to_date_month = today.endOf('month').toDate()
            }
            else {
                from_date_month = today.startOf('month').toDate()
                to_date_month = today.endOf('month').toDate()
            }

            novosFiltros = {
                data_inicial: moment(from_date_month).add(valor, tipoContagem).format('DD/MM/YYYY'),
                data_final: moment(to_date_month).add(valor, tipoContagem).endOf('month').format('DD/MM/YYYY'), ...novosFiltros
            }

            break;
        default:
            break;
    }
    return novosFiltros;
}

const formatMoeda = value => (value / 100 * 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', })

const formatTwoPlace = value => (value / 100 * 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })

const capitalize = string => string.toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase())


const reduzTexto = (text, length) => {
    if (text == null) {
        return "";
    }
    if (text.length <= length) {
        return text;
    }
    text = text.substring(0, length);
    let last = text.lastIndexOf(" ");
    text = text.substring(0, last);
    return text + "...";
}

const toText = (x) => {
    if (x == null) return "";
    if (typeof x === "string") return x;
    if (typeof x === "number" || typeof x === "boolean") return String(x);

    // Se for erro (Error)
    if (x instanceof Error) return x.message || String(x);

    // Se for objeto, tenta campos comuns
    if (typeof x === "object") {
        return (
            x.mensagem ??
            x.message ??
            x.descricao ??
            x.detail ??
            x.error ??
            // fallback seguro
            JSON.stringify(x, null, 2)
        );
    }

    return String(x);
};

export { excluir, auditar, removeAcentos, ordenarArrayObj, emptyObject, downloadArquivoS3, calcularData, formatMoeda, formatTwoPlace, capitalize, reduzTexto, toText }